import { TFunction } from 'i18next';
import {
  ParameterCategoryResponseV2,
  ParameterCategoryView,
  ParameterModel,
  ParameterResponseV2,
  ParametersList,
} from 'types/trackmanParameters';
import { primaryCategoriesOrder, subCategoriesOrder } from './categoriesOrder';

export const formatCategoryKey = (input: string): string =>
  input
    .split('-')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join('');

export const mapV1ToView = (data: ParametersList, t: TFunction): ParameterCategoryView[] =>
  Object.entries(data)
    .sort((a, b) => primaryCategoriesOrder.indexOf(a[0]) - primaryCategoriesOrder.indexOf(b[0]))
    .map(([categoryKey, subcategories]) => ({
      id: categoryKey,
      title: t(formatCategoryKey(categoryKey), { ns: 'trackmanParameters' }),
      subcategories: Object.entries(subcategories)
        .sort((a, b) => subCategoriesOrder[categoryKey].indexOf(a[0]) - subCategoriesOrder[categoryKey].indexOf(b[0]))
        .map(([subcategoryKey, parameters]) => ({
          id: subcategoryKey,
          title: t(subcategoryKey, { ns: 'trackmanParameters' }),
          parameters: parameters.map(mapV1Parameter),
        })),
    }));

const mapV1Parameter = (p: ParameterModel): ParameterModel => ({
  ...p,
  legendData: p.legendData ?? [],
  averageTourData: p.averageTourData ?? null,
});

export const mapV2ToView = (data: ParameterCategoryResponseV2[]): ParameterCategoryView[] =>
  data.map((category) => ({
    id: category.id,
    title: category.title,
    subcategories: category.subcategories.map((subcategory) => ({
      id: subcategory.id,
      title: subcategory.title,
      parameters: subcategory.parameters.map(mapV2Parameter),
    })),
  }));

const mapV2Parameter = (p: ParameterResponseV2): ParameterModel => ({
  id: p.id,
  title: p.title,
  mediaType: p.mediaType,
  mainImgUrl: p.mainImgUrl,
  threeDModelUrl: p.threeDModelUrl,
  definition: p.definition,
  usageInfo: p.usageInfo,
  articlesInfo: p.articlesInfo,
  legendData: p.legendItems.map((l) => ({ legendImageUrl: l.imageUrl, legendDescriptions: l.description })),
  videoUrls: p.videos,
  averageTourData: p.averageTourData ?? null,
});
